import { SxProps } from '@mui/system';
import { Theme } from 'theme';

export const buttonSectionStyle: SxProps<Theme> = {
	display: 'flex',
	justifyContent: 'space-between',
};
